var now = +new Date();

// initial state
export const state = {
    // GUI
    navExpanderOpen: false, // The Hamburger in mobile navigation menu

    // reference books
    /* global FRS_CAMPAIGN */
    campaign: {
        short_url: FRS_CAMPAIGN
    },
    catalog: {},
    countries: {},
    regions: {},

    marketing: {},

    // cart
    items: [],
    isOrderCompleted: false,
    orderId: 0,

    // address handling structures
    billingAddressId: now,
    selectedAddressId: now, // can be set to billing or another address ID depending on a value of shipTo flag
    addresses: {
        // default data for billing address
        [now]: {
            address_id: now,
            first_name: '',
            middle_name: '',
            last_name: '',
            address1: '',
            address2: '',
            company: '',
            city: '',
            country: 'US',
            postal_code: '',
            state_prov: '',
            // additional
            phone: '',
            email: ''
        }
    },
    creditCard: {
        types: {},
        yearNow: 1970,
        yearsCount: 15,
        monthes: [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ]
    },
    shipTo: 'ship2billing', // 'ship2billing' // 'ship2another' // 'ship2multiple'
    // mapping each deliverable line item (or GC as a whole) to registered address ID
    addressMap: {
        // setIndex0_childId_positionIndex: addressId,
        // setIndex1_childId_positionIndex: addressId,
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/index.js